import { DateTimeConstants } from '../constants/shared/dateTimeConstants';

const { DEBOUNCE_IN_MS } = DateTimeConstants;
const { MS_400 } = DEBOUNCE_IN_MS;

export const debounce = <Params extends unknown[]>(
  func: (...args: Params) => void,
  timeoutInMS: number = MS_400
): ((...args: Params) => void) => {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return (...args: Params) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => func(...args), timeoutInMS);
  };
};
